import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.0_@types+no_76703460bd67a1ba97269b9848e6c872/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/node_modules/.pnpm/sanitize.css@11.0.1/node_modules/sanitize.css/sanitize.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/node_modules/.pnpm/sanitize.css@11.0.1/node_modules/sanitize.css/typography.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/web/apps/offspring/src/styles/base.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/node_modules/.pnpm/react-aspect-ratio@1.1.9_react@19.2.3/node_modules/react-aspect-ratio/aspect-ratio.css");
